import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PlacesAutocomplete from 'react-places-autocomplete';
import styles from './VenueField.scss';
import PoweredByGoogle from 'assets/images/powered-by-google.png';

class VenueField extends Component {
  static propTypes = {
    input: PropTypes.object.isRequired,
    inputClassName: PropTypes.string,
    meta: PropTypes.object,
    inputProps: PropTypes.object.isRequired,
  }

  updateValue(newData) {
    if (this.props.input.value === '') { return newData; }
    return Object.assign({}, this.props.input.value, newData);
  }

  onSelect = (address, placeId) => {
    this.props.inputProps.onVenueSelect(placeId, address);
  }

  onAddressChange = (e) => {
    if (e === '') {
      this.props.input.onChange({});
    } else {
      this.props.input.onChange(this.updateValue({ full_address: e }));
    }
  }

  renderSuggestion = ({ formattedSuggestion }) => (
    <div className={styles.suggestionItem}>
      <i className="fa fa-map-marker"/>
      <span className="suggesion">
        {formattedSuggestion.mainText}
        <small className="text-muted">{formattedSuggestion.secondaryText}</small>
      </span>
    </div>
  );

  renderFooter = () => (
    <div className={styles.footer}>
      <div>
        <img src={PoweredByGoogle} />
      </div>
    </div>
  )

  render() {
    const { input } = this.props;
    const cssClasses = {
      input: `form-control ${this.props.inputClassName}`,
      autocompleteContainer: styles.autocompleteContainer,
      autocompleteItem: styles.autocompleteItem,
      autocompleteItemActive: styles.autocompleteItemActive,
    };

    const searchOptions = this.props.inputProps.searchOptions || {};

    return (
      <PlacesAutocomplete
        renderSuggestion={this.renderSuggestion}
        inputProps={{
          name: 'venue-search',
          value: input.value.full_address,
          onChange: this.onAddressChange,
          onBlur: () => input.onBlur(input.value || {}),
          placeholder: this.props.inputProps.placeholder
        }}
        renderFooter={this.renderFooter}
        onSelect={this.onSelect}
        classNames={cssClasses}
        options={searchOptions}
      />
    );
  }
}

const wrapper = (props, error, componentProps) => (
  <VenueField {...props} inputClassName={componentProps.className}/>
);

export default wrapper;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/VenueField.jsx